export const buildingPayment = {
    "welcome": "Bienvenido",
    "welcome_without_entrance": "Bienvenido a {{streetNumber}} {{street}}, {{city}}",
    "welcome_with_entrance": "Bienvenido a {{streetNumber}} {{street}} entrada {{entrance}}, {{city}}",
    "welcome_to": "Bienvenido a",
    "payment_co_op": "Pagos del edificio",
    "payment_to": "Pagos del edificio para ",
    "first_payment": "Primer pago",
    "installment_cost": "Costo de la cuota",
    "payment_does_not_take_credit": "El pago no incluye la línea de crédito",
    "first_charge_one_payment_only": "Total a cobrar",
    "payment_services": "Servicios de pago",
    "payment_services_via_tranzila": "Servicios de pago seguro a través de Tranzila LTD",
    "tourist_comment": "El pago con tarjeta de turista tendrá una comisión adicional que se cobrará por separado en los próximos días",
    "confirmation_email": "La confirmación también se envía por correo electrónico",
    "empty": "",
    "address_without_entrance": "{{street}} {{streetNumber}}, {{apartmentText}} {{city}}",
    "address_with_entrance": "{{street}} {{streetNumber}} כניסה {{entrance}}, {{apartmentText}} {{city}}",
    "apartmentText": "Apartamento {{apartmentNumber}}",
    "buildingPageExplain": "Has llegado a la página de tu edificio. Aquí puedes realizar todos los pagos cooperativos",
    "updates": "Actualizaciones para los inquilinos del edificio",
    "payment_method": "Pago a través de",
    "managers": "Administradores del edificio",
    "makePayment": "Pagar",
    "fill_in_details_secondary_title": "Completa tus datos personales y del apartamento",
    "details_of_payer": "Datos del cliente",
    "number_of_apartment": "Número de apartamento",
    "full_name": "Nombre completo",
    "type_of_tenant": "Propiedad",
    "renter": "Inquilino",
    "owner": "Propietario",
    "phone": "Teléfono móvil",
    "email": "Correo electrónico",
    "comment": "Comentario:",
    "agree_to_ads": "Aceptar recibir correos de bllink.co",
    "accept_website_tos": "Al firmar aquí, acepto ",
    "tos": "Términos de servicio",
    "next": "Siguiente",
    "update_personal_details": "Actualizar datos personales",
    "pay_debt": "Pago de los meses anteriores",
    "pay_on_going": "Pago cooperativo",
    "pay_one_time": "Pagos únicos",
    "pay_expense": "Pago de gastos",
    "debt_title": "Meses sin pagar",
    "debt_sub_title": "Se acumuló una deuda por el monto de {{amount}} {{currency}} para su apartamento",
    "on_going_title": "Pago mensual",
    /** @deprecated use currency.ils instead  */ "ils": "₪",
    /** @deprecated use currency.mxn instead  */ "mxn": "$",
    /** @deprecated use currency.gbp instead  */ "gbp": "£",
    /** @deprecated use currency.eur instead  */ "eur": "€",
    "total_to_pay": "Total",
    "first_charge": "Primer pago total",
    "number_of_installments": "Cantidad de cuotas",
    "monthly_payment": "Total mensual",
    "months_selected": "Meses",
    "month_selected": "Mes",
    "future_payments_by_months": "Monto a pagar los próximos meses",
    "future_payments_sub_title": "Estos son los próximos pagos definidos según tu selección",
    "future_payments_additional_title": "Atención: el pago de Bllink no alcanza el límite de crédito",
    "automatic_billing_note": "Su plan de pago se renovará automáticamente si no recibimos su respuesta para renovar por mensaje de texto",
    "pay_with_bank_permission": "Directamente de la cuenta bancaria",
    "pay_credit_card": "Tarjeta de crédito",
    "everything_is_paid": "Todo está pagado para",
    "confirmation_title": "Recibo de pago",
    "4_last_digits": "Últimos 4 dígitos",
    "payment_for": "Pago de",
    "card_type": "Tarjeta",
    "charge_card": "Pagar",
    "transaction_date": "Fecha de transacción",
    "no_confirmation_yet": "Sin confirmación todavía",
    "proceed_to_checkout": "Proceder a la compra",
    "back": "Atrás",
    "harshaaFileName": "accountPermissions.pdf",
    "call_us_for_bank_allow": "llámanos para configurar el cargo bancario. 03-5090045",
    "call_us_for_bank_allow_title": "Configuración bancaria en 5 minutos",
    "confirmation_id": "Confirmación",
    "dont_accept_america_express_cards": "¿American Express? Lamentablemente, American Express es la única tarjeta que no aceptamos en este momento. Intenta con una tarjeta diferente.",
    "payment_error": "Error de pago",
    "incorrect_cvv": "Verifica los 3 dígitos del reverso de la tarjeta CVV",
    "cart_empty_title": "El carrito está vacío",
    "cart_empty_text": "No seleccionaste ningún elemento, no puedes pasar a la siguiente pantalla. Marca al menos un elemento",
    "offline_payment_amounts_are_wrong": "El monto de los pagos es incorrecto",
    "offline_payment_amounts_are_wrong_text": "Los pagos establecidos son {{amountsSent}}, pero el monto requerido es {{totalToPay}}",
    "commissionTextForTenantInPercentage": "El pago incluye un porcentaje de comisión {{commissionPercentage}} %",
    "commissionTextForTenantInInDollars": "La comisión total por pago es {{commissionInDollars}} {{currency}}",
    "confirmationNumbersText": "Referencias de transacciones",
    "buildingPageExplain-1": "Me alegro de verte",
    "buildingPageExplain-2": "Haz clic en pagar y pasa al pago inteligente",
    "sub_title_before_payment": "Revisa los detalles antes de pagar",
    "record_expenses": "Registrar gastos ",
    "renewal_for": "Renovación para",
    "renewal_title": "Formulario de renovación",
    "renew_months_forward": "{{numberOfMonths}} meses",
    "renew_option": "Renueva por",
    "dont_renew_option": "No renovar porque",
    "bllink_bank_charge": "Bllink",
    "update_credit_card": "Actualizar tarjeta de crédito",
    "failed_payment_title": "Actualizar la página de la tarjeta de crédito",
    "renew_send": "Enviar",
    "already_recorded_response_for_renewal": "Ya registramos tu respuesta",
    "expense_edit": "Editar gastos",
    "setup_using_this_flow": "Se creó un plan de pago. Ahora todo lo que queda por hacer es configurar los permisos del cargo bancario",
    "setup_using_this_flow_1": "El proceso completo dura unos 5 minutos y se recomienda iniciar desde una computadora y no desde un teléfono móvil",
    "setup_using_this_flow_2": "puedes usar",
    "setup_using_this_flow_3": "En la guía para configurar una autorización de débito de la cuenta\n",
    "setup_using_this_flow_4": "Nota 💙 Para establecer la autorización, debes pagar un costo único de comisión del banco por un monto de NIS 15",
    "setup_auto_charge": "También puedes configurar un cargo automático desde tu cuenta bancaria",
    "future_payment_date": "Fecha de pago futura",
    "address": "Dirección",
    "month": "Para el mes:",
    "year": "Año",
    "canceled_deal": "Transacción cancelada",
    "payment_have_commission": "El pago que se muestra incluye una tarifa de compensación",
    "payment_confirmation": "Pago realizado con éxito, será llevado a la página de confirmación de pago en unos segundos",
    "here": "Aquí",
    "cant_pay_with_credit_card": "Ups... no puedes hacer un pago por estos meses con tarjeta de crédito",
    "cant_pay_with_credit_card_text": "No es posible pagar con tarjeta de crédito el carrito actual. Para el pago con tarjeta de crédito, cancelar el marcado de pago hasta mensualmente",
    "tenant_details_missing_title": "Faltan detalles del inquilino",
    "tenant_details_missing_text": "Faltan detalles del inquilino. Vuelva a la pantalla 'Actualización de privacidad personal' y complete sus datos",
    "dont_renew_moved": "Me mude de apartamento",
    "dont_renew_call_me": "Interesado en que me contacten",
    "dont_renew_paid_via_cheque": "Ya he pagado con cheques",
    "dont_renew_other": "Otro motivo",
    "already_updated_this_failed_payment": "Los datos de la tarjeta de crédito para este pago ya se han actualizado",
    "payment_plan_not_active_pay_at_building_page": "El enlace ya no está activo. Puede pagar la deuda a través del pilar del edificio.",
    "submitted_renew_response_successfully": "Excelente, la mensualidad de acuerdo a la cantidad de meses seleccionados. La confirmación llegará al correo electrónico en los próximos minutos.",
    "submitted_dont_renew_response_successfully": "Hemos recibido tu respuesta. Gracias",
    "cart_has_been_payed_already": "Ya se ha realizado el pago de este carrito, se le llevará a la confirmación de pago",
    "tzla_script_load_failed": "No se puede inicializar el formulario de tarjeta de crédito, intente más tarde u otro dispositivo o navegador",
    "select_placeholder": "Seleccionar...",
    "open_new_building": "Abrir nuevo edificio",
    "choose_action": "Elige tu acción",
    "proceed_to_payment": "Proceder a establecer un pago",
    "proceed_to_tasks": "Continuar con las tareas de mantenimiento",
    "contact_manager": "Póngase en contacto con el administrador del edificio",
    "installments_available": "Cuotas disponibles en la página de pago",
    "learn_more": "Aprende más?",
    "contact_manager_subheader": "Contactar al gerente o iniciar una conversación",
    "start_chat": "Comenzar chat",
    "manager_name": "Nombre del administrador del edificio",
    "manager_phone": "Teléfono del administrador del edificio",
    "manager_email": "Correo electrónico del administrador del edificio",
    "how_to_pay": "¿Cómo le gustaría pagar los gastos de pensión de la casa?",
    "bank": "Banco",
    "bit": "Bit pago",
    "cheque": "Controlar",
    "applePay": "Apply pay pago",
    "fill_details": "Rellena tus datos para enviar la confirmación del pago",
    "mail": "Correo electrónico",
    "terms_of_use": "Acepto los",
    "confirm_mail": "Confirmo haber recibido anuncios de Blink",
    "please_fill": "Por favor llene todos los campos requeridos",
    "payment_will_renew": "Al final del período elegido, el pago se renovará automáticamente. Se enviará un mensaje de texto antes de la renovación",
    "debt_amount": "Monto de la deuda",
    "monthly_fee": "Cuota mensual",
    "selected_months": "Meses seleccionados",
    "click_to_view": "Haga clic para ver los pagos de los inquilinos",
    "show_owner_payments": "Mostrar pagos del propietario",
    "show_renter_payments": "Mostrar pagos de inquilinos",
    "months_details": "Detalles de los meses",
    "special_payment": "Pago especial",
    "special_details": "Detalles especiales",
    "debt_amount_past": "Monto de la deuda (últimos años)",
    "current_year_amount": "Importe del año actual",
    "selected_payments": "Pagos seleccionados",
    "apply": "Solicitar",
    "mark_as_paid": "Marcar como pagado",
    "success": "Éxito",
    "no_payments_selected": "No se seleccionaron pagos",
    "on_going": "Pagos en curso",
    "past": "Deuda abierta",
    "no_open_payments": "No hay pagos abiertos",
    "select_date": "Seleccione una fecha",
    "checkout_info": "Al final del período seleccionado, la cuota mensual se renovará automáticamente. Se enviará un aviso con posibilidad de cancelación antes de la renovación.",
    "bit_info": "Para recibir la solicitud de pago, haga clic en el botón pagar con bit y luego ingrese un número de teléfono / escanee el código QR / Haga clic en el botón para cambiar a la aplicación Bit (para usuarios móviles)",
    "payment_page": "Pagina de pago",
    "payment_plan_was_not_created": "No se creó el plan de pago",
    "debts": "Mensual - deudas",
    "onGoing": "Mensual - en curso",
    "show_details": "Mostrar detalles",
    "total": "Total",
    "distribution_cost": "Costo de distribución de pagos",
    "first_date": "Primera fecha de pago",
    "fixed_day": "Día de pago fijo",
    "payment_note": "Al pago se le añadirá una comisión del 1,4%. El pago con una tarjeta extranjera (de turista) tendrá un cargo adicional que se cobrará por separado en los próximos días.",
    "digital_signature": "Firma digital",
    "credit_card": "Tarjeta de crédito",
    "notice": "Darse cuenta",
    "notice_info": "Porque hay 10 días hábiles para aprobar tus datos bancarios. El primer pago se cobrará el próximo mes.",
    "spread_payment": "¿Quieres repartir un pago de deuda o un pago especial?",
    "when_deploy_payments": "¿Cuándo puedo implementar pagos?",
    "divide_payments_info": "Por lo general, un pago de deuda o un pago especial se puede pagar en un solo pago. A través de Blink, la cantidad se puede dividir en pagos iguales que le permitirán una flexibilidad total.",
    "how_to_divide": "¿Cómo haces la división?",
    "division_info": "Muy pronto lanzaremos la opción de realizar el deployment directamente desde el sistema. Hasta entonces... nuestros representantes están disponibles para hacer la distribución por usted por teléfono.",
    "contact_info": "Información del contacto",
    "moked_bllink": "Moked Bllink",
    "back_to_payments": "Volver a pagos",
    "contact_representative": "Contactar con un representante",
    "comissionOn": "Sin captura de fotogramas",
    "noComission": "Gratis y sin captura de fotogramas",
    "directTransferPayment": "Pago por transferencia directa a la cuenta",
    "chooseBankPayment": "Debes elegir la forma de pago a través del banco",
    "directPayment": "Transferencia directa",
    "digitalPermission": "Permiso digital",
    "amountToTransfer": "Monto a transferir",
    "verificationCode": "Código de verificación",
    "transferNote": "(Para agregar como nota o como motivo de la transferencia)",
    "paymentConfirmationWillBeSent": "*La confirmación del pago se enviará después de la confirmación del código de verificación adjunto a la nota de transferencia",
    "copyCode": "Copiar código",
    "bankAccountDetails": "Información de cuenta bancaria",
    "byOrderBllink": "Por pedido - Bllink Systems Ltd",
    "copied": "Copiado al portapapeles!",
    "installmentDisabled": "No es posible fraccionar cuotas con este método de pago",
    "paymentThroughBank": "Pago a través del banco",
    "howToMakePayment": "¿Cómo se realiza un pago por transferencia bancaria?",
    "directTransfer": "Transferencia bancaria directa",
    "digitalAuth": "Establecimiento de una autorización digital",
    "fillDetailsForTransfer": "Después de completar los detalles, se mostrarán los detalles de la cuenta para la transferencia, se requiere adjuntar el código de verificación que se muestra a la nota/motivo de la transferencia",
    "confirmationOrPending": "Si no se adjunta confirmación, el pago no se verificará y se mostrará como pago pendiente",
    "fastSignProcess": "Un rápido proceso de firma digital para el pago directamente desde la cuenta bancaria",
    "tenDaysToVerify": "Se requiere el primer pago durante 10 días hábiles para verificar los detalles",
    "savingMoney": "¡Ahorrándote dinero todos los meses!",
    "insuranceSavings": "Ahorro de hasta el 50% en seguro hipotecario",
    "weSavedUpTo": "Hasta ahora, hemos ahorrado a nuestros clientes un promedio de 250₪ por mes, ¿no te gustaría eso también?",
    "ourCostomersChoose": "De 10 clientes de Bllink 8 ya han contratado un seguro hipotecario en GUR, ¿y tú?",
    "checkHowMuchCanBeSaved": "Haga clic y compruebe cuánto se puede ahorrar para usted",
    "scheduleCall": "Para programar una llamada",
    "continueToConfirmPayment": "Continuar para confirmar un pago",
    "representativeWillContactYou": "Nuestro representante se comunicará con usted pronto",
    "contextLost": "Contexto perdido. Navegando al primer paso",
    "contextLostAtAll": "Contexto perdido. Por favor, da el primer paso",
};
